import React from "react";
import { FieldInputProps } from "react-final-form";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";

import FormControlError from "components/FormControl/FormControlError";

import { Container } from "./styles";

type DictionaryItem = {
  value: any;
  label: string;
};

type Props = {
  input: FieldInputProps<any>;
  onChange: (item: DictionaryItem) => void;
};

export type RadioButtonExternalProps = {
  options: Array<DictionaryItem>;
  disabled?: boolean;
  inline?: boolean;
  label?: string;
  required?: boolean;
  error?: string;
};

class RadioButtonGroup extends React.Component<
  Props & RadioButtonExternalProps
> {
  get input() {
    const { input } = this.props;

    return input;
  }

  onChange = (event: any) => {
    const { onChange } = this.props;

    const value = event.target.value;
    onChange({ value });
  };

  render() {
    const { disabled, inline, error, label, options, required } = this.props;

    return (
      <Container>
        {label && (
          <FormLabel required={required} error={!!error}>
            {label}
          </FormLabel>
        )}
        <RadioGroup
          value={this.input.value}
          onChange={this.onChange}
          row={inline}
        >
          {options.map(option => (
            <FormControlLabel
              key={option.value}
              label={option.label}
              value={option.value}
              control={
                <Radio color={"primary"} size="small" disabled={disabled} />
              }
            />
          ))}
        </RadioGroup>
        {error && <FormControlError error={error} />}
      </Container>
    );
  }
}

export default RadioButtonGroup;
